import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=0686b0f7&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=js"
export * from "./PopupNotification.vue?vue&type=script&lang=js"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=0686b0f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686b0f7",
  null
  
)

export default component.exports